import { filterCutoff, updateInstantSlot } from "../../config/Services";

// Format a Date as a local "YYYY-MM-DDTHH:mm:ss" string (no UTC shift).
const toLocalIso = (d) => {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
};

export const fetchSlotList = ({ date, orgId, locId }) => {
  const initialDate = date ? new Date(date) : new Date();

  const startOfDay = new Date(initialDate);
  startOfDay.setHours(0, 0, 0, 0);

  const endOfDay = new Date(initialDate);
  endOfDay.setHours(23, 59, 59, 999);

  const instantDate = new Date(initialDate);
  instantDate.setHours(0, 0, 0, 0);

  const payload = {
    slotStartTime: startOfDay.toISOString().slice(0, 19),
    slotEndTime: endOfDay.toISOString().slice(0, 19),
    slotIsDeletedList: [false],
    sourceIdList: [orgId],
    sourceLocationIdList: [locId],
    sortByStartTime: "ASCENDING",
    isRequiredInstantDelivery: true,
    // Local date (not UTC) so the backend matches the configured instant slot for today.
    instantDeliveryDate: toLocalIso(instantDate),
  };

  return filterCutoff(payload)
    .then((response) => {
      const data = response?.data?.data;
      return data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const updateInstantDeliverySlot = (payload) => {
  return updateInstantSlot(payload)
    .then((response) => {
      return response?.data?.data;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
